<!--
 * @Description: 通用 footer 组件
 * @Author: hasayake
 * @Date: 2020-04-13 16:30:46
 * @LastEditTime: 2020-04-13 18:30:04
 * @LastEditors: Please set LastEditors
-->

<template functional>
  <footer class="footer__wrapper">
    <div class="footer-main">
      <div class="footer-nav">
        <a href="javascript:;">帮助</a>
        <a href="javascript:;">隐私</a>
        <a href="javascript:;">条款</a>
      </div>
      <div>2020 北京维卓网络技术部出品</div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'pubFooter'
}
</script>

<style lang="scss">
$footerColor: #909399;

.footer__wrapper {
  position: fixed;
  bottom: 18px;
  z-index: 2;

  .footer-main {
    width: 164px;
    margin: 0 auto;
    text-align: center;
    color: $footerColor;
    font-size: 12px;

    .footer-nav {
      display: flex;
      width: 164px;
      margin-bottom: 10px;
      justify-content: space-between;
    }

    a {
      color: $footerColor;

      &:nth-child(2) {
        border-left: 1px solid $footerColor;
        border-right: 1px solid $footerColor;
        padding: 0 25px;
      }
    }
  }
}
</style>
